angular.module('webtrader').service('ModalWindow', function($http, $document) {

  this.modalChoices = {
    "registration": REGISTRATION_URL,
    "invitation": BASE_URL+'templates/modal.invitation.html'
  }
 
  this.createTemplate = (data) => {
    return `<div id="modal-window" class='modals-wrapper'>
              <div class='reveal-modal open reveal-modal-alt' data-reveal>
                ${data}
              </div>
            </div>`
  }

  this.init = (data) => {
    angular.element($document[0].body).append(this.createTemplate(data))
    this.modal = angular.element(document.getElementById("modal-window"))
    angular.element(this.modal[0].querySelector(".close-reveal-modal")).bind("click", this.close)
  }

  this.open = (modalName) => {
    return $http.get(this.modalChoices[modalName]).then((res) => {
      this.init(res.data)
    })
  }

  this.close = () => {
    this.modal.remove()
  }
})